import React, {Fragment} from "react";
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";
import {withRouter} from "react-router-dom";

import FormGroup from '@mui/material/FormGroup';
import Button from "@mui/material/Button";

import GroheCartLoginRegisterInputs from "./groheCartLoginRegisterInputs";
import {ROUTES} from "../../../../../routes";
import GroheCartLoginRegisterCheckbox from "./groheCartLoginRegisterCheckbox";
import GroheCartHeaderCommon from "../groheCartHeaderCommon";
import GroheCartStickyFooter from "../groheCartStickyFooter";
import WithInputValidations from "../../../hocs/withInputValidations";
import {PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../../analytics";
import {registerButtonCommonClick, saveQuoteAfterSignIn} from "../../../../../misc/userFunctions";

const GroheCartLoginRegister = (props) => {

  const {isMobile, history, userInfo, fabricatorSettings} = props;

  const executeAfterRegister = async () => {
    await saveQuoteAfterSignIn();
    if (fabricatorSettings.twoFA) {
      history.push(ROUTES.cartTwoFA);
    } else if (fabricatorSettings.hasPaymentGateway) {
      history.push(ROUTES.cartBilling);
    } else {
      history.push(ROUTES.cartConfirm);
    }
  };

  const registerButtonClick = async (updateInputValidations) => {
    const registered = await registerButtonCommonClick(updateInputValidations, PRODUCT_JOURNEY_ANALYTIC_EVENTS.cartCheckoutRegister, executeAfterRegister);
    if (!registered) {
      return false
    }
    await executeAfterRegister();
  }

  const registerForm = (inputsValidated, updateInputValidations) => (
    <FormGroup className="gc-form gc-form--register">
      {isMobile ? null : (
        <Fragment>
          <h2 className="gc-header__title">
            <FormattedMessage id="grohe.cart.login.register.title"/>
          </h2>
          <p className="gc-header__sub-title">
            <FormattedMessage id="grohe.cart.login.register.subTitle"/>
          </p>
        </Fragment>
      )}
      <GroheCartLoginRegisterInputs inputsValidated={inputsValidated}/>
      <div className="gc-form__submit">
        <div className="gc-form__submit-left">
          <GroheCartLoginRegisterCheckbox/>
        </div>
        {isMobile ? null : (
          <div className="gc-form__submit-right">
            <Button className="look-button look-button--blue look-button--big look-button--large nowrap"
                    disabled={!userInfo.agreedToTerms}
                    onClick={() => registerButtonClick(updateInputValidations)}>
              <FormattedMessage id="grohe.cart.login.register.button"/>
            </Button>
          </div>
        )}
      </div>
    </FormGroup>
  )

  if (isMobile) {
    return (
      <WithInputValidations>
        {(inputsValidated, updateInputValidations) => {

          const stickyFooterButtons = [
            {
              translate: "buttons.back",
              classes: "look-button--secondary",
              onClick: () => {
                history.push(ROUTES.cart);
              }
            },
            {
              translate: "grohe.cart.register.mobile.alreadyRegisteredButton",
              classes: "look-button--secondary gc-sticky__button--40",
              onClick: () => {
                history.push(ROUTES.cartLogin);
              }
            },
            {
              translate: "grohe.cart.login.register.button",
              classes: "look-button--blue gc-sticky__button--40",
              onClick: () => registerButtonClick(updateInputValidations),
              disabled: !userInfo.agreedToTerms
            }
          ];

          return (
            <div className="gc">
              <div className="gc-body">
                <GroheCartHeaderCommon title="grohe.cart.login.register.title"
                                       subTitle="grohe.cart.register.mobile.subTitle"/>
                {registerForm(inputsValidated, updateInputValidations)}
                <div className="gc-spacer"/>
              </div>
              <GroheCartStickyFooter stickyFooterButtons={stickyFooterButtons}/>
            </div>
          )
        }}
      </WithInputValidations>
    )
  }

  return (
    <WithInputValidations>
      {(inputsValidated, updateInputValidations) => registerForm(inputsValidated, updateInputValidations)}
    </WithInputValidations>
  )
};

const mapStateToProps = (store) => {
  const {userInfo} = store.userState;
  const {isMobile} = store.serverState;
  const {settings} = store.fabricatorState;
  return {
    userInfo,
    fabricatorSettings: settings,
    isMobile
  };
};

const mapDispatchToProps = {
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(GroheCartLoginRegister)
)
